
import components from './components/index.js';
import dialogs from './dialogs/index.js';
import pages from './pages/index.js';
import appcaches from './caches/index.js';
import jsSHA from 'jssha';
import Plugin from './lib/Plugin.js';
import CryptoUtils from './lib/CryptoUtils.js';
import PackageJSON from '../package.json';

window.JSSHA = jsSHA;
window.Grape.CryptoUtils = CryptoUtils;

document.addEventListener('DOMContentLoaded', () => {

	window.Grape.modules.push(PackageJSON);

	window.Grape.cache.registerCaches(appcaches);
	window.Grape.component.registerComponents(components);
	window.Grape.dialog.registerDialogs(dialogs);
	window.Grape.pages.registerPages(pages);

	Grape.plugins.register(Plugin);
});

if (!window.UserAccountPlugins)
	window.UserAccountPlugins = [];
